(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-details"] && !Shopify.designMode) return;
  try {
    
  const productDetailsDesktop = window.matchMedia('(min-width: 700px)');

  function syncProductDetails(section) {
    section.querySelectorAll('.product-details__item').forEach((item) => {
      item.open = productDetailsDesktop.matches;
    });
  }

  function syncAllProductDetails() {
    document.querySelectorAll('.product-details-section').forEach(syncProductDetails);
  }

  syncAllProductDetails();
  productDetailsDesktop.addEventListener('change', syncAllProductDetails);

  document.addEventListener('shopify:section:load', (event) => {
    const section = event.target.querySelector('.product-details-section');

    if (section) {
      syncProductDetails(section);
    }
  });

  document.addEventListener(
    'toggle',
    (event) => {
      const item = event.target;

      if (productDetailsDesktop.matches || !item.matches('.product-details__item') || !item.open) {
        return;
      }

      item.closest('.product-details').querySelectorAll('.product-details__item[open]').forEach((sibling) => {
        if (sibling !== item) {
          sibling.open = false;
        }
      });
    },
    true
  );

  } catch(e) { console.error(e); }
})();
})();
